// extracted by mini-css-extract-plugin
export default {"root":"BlockSocialMediaLink_root__a3MCG","link":"BlockSocialMediaLink_link__Dh5ep","media":"BlockSocialMediaLink_media__nLk5A","text":"BlockSocialMediaLink_text__+8uID"};